const ErrorBanner = ({ onRetry }) => (
  <div className="flex items-center justify-between bg-red-50 border border-red-100 text-red-600 rounded-xl px-4 py-2.5">
    <div className="flex items-center gap-2 text-sm">
      <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="text-xs font-medium">Failed to load dashboard data.</span>
    </div>
    <button
      onClick={onRetry}
      className="ml-4 px-3 py-1 text-xs font-semibold bg-red-100 hover:bg-red-200 text-red-700 rounded-lg transition-colors"
    >
      Retry
    </button>
  </div>
);

export default ErrorBanner;
